import { memo } from "react";
import { CommentActions } from "@crunchyroll/cx-web-components";

import { useComments } from "../hooks/useComments";
import CommentActionsTooltip from "./CommentActionsTooltip";
import CommentLike from "./CommentLike";

export const CommentActionsContainer = memo(({ id }) => {
  const { byId } = useComments();
  const comment = byId[id];

  if (!comment || comment?.isCommentDeleted || comment?.isDeletionInProgress) {
    return null;
  }

  const { isSpoilerHidden } = comment;

  return (
    <CommentActionsTooltip isVisible={isSpoilerHidden}>
      <CommentActions isDisabled={isSpoilerHidden}>
        <CommentLike id={id} />
      </CommentActions>
    </CommentActionsTooltip>
  );
});
